module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAKAgMAAACLeOXiAAAACVBMVEUAAAD///////9zeKVjAAAAAnRSTlMAy3ol1gAAAAAeSURBVAjXY8hahQAT0Hj4ARtE2UoMHmGQBTQckwcA4ZgdL+5XJJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-9.png
// module id = i+i5
// module chunks = 1